
import Vue from "vue";
import { format_minutes_to_hours_minutes } from "@/utils/global";

export default Vue.extend({
  name: "AppTimer",
  data() {
    return {
      time: 0, // Remaining time in seconds
      startTimestamp: 0, // Timestamp when timer starts
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      time_interval: 0 as any, // Interval ID
      totalTimeForRun: 0, // Total seconds for current run (used when resuming after pause)
      isPaused: false,
      current_color_index: 0,
      colors: ["primary", "warning", "error"]
      // Removed toggle approach for smoother CSS animation
    };
  },
  props: {
    time_seconds: { type: Number, required: true },
    start_timer: { type: Boolean, default: true },
    /** When true, pauses countdown when tab is hidden (e.g. user switches away) so time away does not count against the assessment */
    pauseWhenHidden: { type: Boolean, default: false },
    intervals: { type: Number, default: 3 },
    // Change color when remaining seconds <= threshold
    last_minute_threshold: { type: Number, default: 60 },
    last_minute_color: { type: String, default: "error" },
    // Warning color for last X minutes (default 5 minutes)
    warning_threshold: { type: Number, default: 300 } // 5 * 60
  },
  mounted() {
    this.time = this.time_seconds;
    this.totalTimeForRun = this.time_seconds;
    if (this.start_timer) this.startTimer();
    if (this.pauseWhenHidden) {
      document.addEventListener(
        "visibilitychange",
        this.handleVisibilityChange
      );
    }
  },
  beforeDestroy() {
    if (this.pauseWhenHidden) {
      document.removeEventListener(
        "visibilitychange",
        this.handleVisibilityChange
      );
    }
    clearInterval(this.time_interval);
  },
  computed: {
    baseColor(): string {
      if (this.time <= this.last_minute_threshold) {
        return this.last_minute_color;
      }
      return "primary";
    },
    pulseClass(): string {
      // Apply pulsing only in warning zone (excluding last minute where color is solid error)
      if (
        this.time <= this.warning_threshold &&
        this.time > this.last_minute_threshold
      ) {
        return "pulse-warning";
      }
      return "";
    }
  },
  watch: {
    start_timer(value) {
      if (value) this.startTimer();
      else clearInterval(this.time_interval);
    }
  },
  methods: {
    format_minutes_to_hours_minutes,
    handleVisibilityChange() {
      if (document.hidden) {
        this.isPaused = true;
        clearInterval(this.time_interval);
        this.time_interval = 0;
      } else {
        this.isPaused = false;
        this.totalTimeForRun = this.time;
        this.startTimer();
      }
    },
    startTimer() {
      clearInterval(this.time_interval);
      const totalTime =
        this.pauseWhenHidden && this.totalTimeForRun > 0
          ? this.totalTimeForRun
          : this.time_seconds;
      this.startTimestamp = Date.now();

      const update = () => {
        const elapsed = Math.floor((Date.now() - this.startTimestamp) / 1000);
        this.time = totalTime - elapsed;

        if (this.time <= 0) {
          this.time = 0;
          clearInterval(this.time_interval);
          this.$emit("time_over");
          return;
        }
      };

      update(); // initial update
      this.time_interval = setInterval(update, 250); // moderate updates; color animation handled by CSS
    }
  }
});
